/* */ 
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trigger = exports.off = exports.once = exports.onAll = exports.on = exports.EVENTS = void 0;

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _this = void 0;

window.eika = window.eika || {};
window.eika.events = window.eika.events || [];
window.eika.otEvents = window.eika.otEvents || [];
var events = window.eika.events;
var otEvents = window.eika.otEvents; // One Time events

var EVENTS = {
  LOGOUT_COMPLETED: '2',
  AGREMENT_SWITCHED: '3',
  // Ikke verifisert
  CHANGE_LANGUAGE_COMPLETED: '4',
  GET_FAVOURITE_ACCOUNTS_COMPLETED: '5',
  SHOW_AGREEMENT_SELECTOR_COMPLETED: '6',
  SHOW_ACCOUNT_LIST_COMPLETED: '7',
  SHOW_ACCOUNT_TERMS_COMPLETED: '8',
  SHOW_ACCOUNT_TRANSACTION_LIST_COMPLETED: '9',
  SHOW_APPROVE_PAYMENTS_COMPLETED: '10',
  SHOW_BLOCK_CARD_COMPLETED: '11',
  SHOW_CREDIT_CARD_LIST_COMPLETED: '12',
  SHOW_CREDIT_CARD_TRANSACTION_LIST_COMPLETED: '13',
  SHOW_CURRENCY_CONVERTER_COMPLETED: '14',
  SHOW_EDIT_FAVORITE_ACCOUNTS_COMPLETED: '15',
  SHOW_E_FAKTURA_DRAG_AND_DROP_FORM_COMPLETED: '16',
  SHOW_E_FAKTURA_LIST_COMPLETED: '17',
  SHOW_E_FAKTURA_PAYMENT_FORM_COMPLETED: '18',
  SHOW_DIALOG_COMPLETED: '19',
  SHOW_FIND_US_COMPLETED: '20',
  SHOW_KID_PAYMENT_FORM_COMPLETED: '21',
  SHOW_LANGUAGE_SELECTOR_COMPLETED: '22',
  SHOW_LOANS_LIST_COMPLETED: '23',
  SHOW_LOANS_TERMS_COMPLETED: '24',
  SHOW_LOANS_TRANSACTION_LIST_COMPLETED: '25',
  SHOW_LOGIN_FORM_COMPLETED: '26',
  SHOW_MESSAGE_LIST_COMPLETED: '27',
  SHOW_MY_ADVISOR_COMPLETED: '28',
  SHOW_PAYMENT_AGREEMENT_LIST_COMPLETED: '29',
  SHOW_SNAP_CASH_COMPLETED: '30',
  SHOW_TRANSFER_FORM_COMPLETED: '31',
  SHOW_TRANSFER_DRAG_AND_DROP_FORM_COMPLETED: '32',
  ENROLL_ACCOUNTS_COMPLETED: '33',
  SHOW_ACCOUNT_TRANSACTION_DETAILS_COMPLETED: '34',
  SHOW_FUTURE_PAYMENT_DETAILS_COMPLETED: '35',
  SHOW_NOTIFICATION_LIST_COMPLETED: '36',
  // Success calls
  LOGIN_SUCCEED: '1',
  LANGUAGE_CHANGE_SUCCEEDED: '50',
  GET_FAVOURITE_ACCOUNTS_SUCCEEDED: '51',
  AGREEMENT_CHANGE_SUCCEEDED: '52',
  FAVORITE_ACCOUNTS_SELECTION_CHANGED: '53',
  EFAKTURA_PAYMENT_SUCCEEDED: '54',
  EFAKTURA_DELETION_SUCCEEDED: '55',
  KID_PAYMENT_SUCCEEDED: '56',
  SNAPCASH_PAYMENT_SUCCEEDED: '57',
  TRANSFER_SUCCEEDED: '58',
  OVERVIEW_CHANGED: '59',
  ENROLL_ACCOUNTS_CHANGED: '60',
  ACCOUNT_NAME_CHANGED: '61',
  ACCOUNT_TRANSACTION_DETAILS_UPDATED: '62',
  FUTURE_PAYMENT_CHANGED: '63',
  ALL_EVENTS: 'ALL'
};
/*
 * Støtter både (event, fn) ellers returneres et promise
 */

exports.EVENTS = EVENTS;

var on = function on(event, fn) {
  if (!events[event]) {
    events[event] = [];
  }

  if (fn) {
    return events[event].push(fn);
  }

  return new Promise(function (resolve) {
    events[event].push(resolve);
  });
};
/*
 * Kaller on på en liste av events
 */


exports.on = on;

var onAll = function onAll(events, fn) {
  events.forEach(function (event) {
    on(event, fn);
  });
};

exports.onAll = onAll;

var once = function once(event, fn) {
  if (!otEvents[event]) {
    otEvents[event] = [];
  }

  if (fn) {
    return otEvents[event].push(fn);
  }

  return new Promise(function (resolve) {
    otEvents[event].push(resolve);
  });
};

exports.once = once;

var turnOff = function turnOff(events, event, fn) {
  if (!events[event]) {
    events[event] = [];
  }

  if (!fn) {
    events[event] = [];
  } else {
    var index = events[event].findIndex(function (cb) {
      return cb === fn;
    });

    if (index >= 0) {
      events[event].splice(index, 1);
    }
  }
};

var off = function off(event, fn) {
  turnOff(events, event, fn);
  turnOff(otEvents, event, fn);
};

exports.off = off;

var trigger = function trigger(event) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (events[event]) {
    events[event].forEach(function (cb) {
      return cb.call.apply(cb, [_this].concat(args));
    });
  } // Mostly for debugging


  if (events[EVENTS.ALL_EVENTS]) {
    events[EVENTS.ALL_EVENTS].forEach(function (cb) {
      return cb.call.apply(cb, [_this].concat(args));
    });
  } // One Time events for fast promise binding


  if (otEvents[event]) {
    otEvents[event].forEach(function (cb) {
      return cb.call.apply(cb, [_this].concat(args));
    });
    turnOff(otEvents, event);
  }
};

exports.trigger = trigger;